import Preview from 'components/Preview';
import React from 'react';
export default {
  Preview,
  React
};